<template>
  <el-row>
    <el-col :span="24">
      <h3 class="form-title">
        {{ id ? "Balans hisobotini tahrirlash" : "Balans hisoboti qo'shish" }}
      </h3>
    </el-col>
    <el-col :span="24">
      <el-form
        v-loading="loading"
        label-position="top"
        ref="formRef"
        :model="form"
        class="psbs-form"
      >
        <el-form-item
          label="Yil"
          prop="year"
          :rules="[{ required: true, message: 'Yilni kiriting' }]"
        >
          <el-input-number
            v-model="form.year"
            :min="1900"
            :max="2100"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item
          label="Excel fayl"
          prop="excel_file_id"
          :rules="[{ required: true, message: 'Faylni yuklang', trigger: 'change' }]"
        >
          <el-input v-model="form.excel_file_id" style="display: none" />
          <input
            type="file"
            ref="fileInputRef"
            hidden
            accept=".xls,.xlsx"
            @change="uploadFile"
          />
          <div class="file-upload-row">
            <el-button :loading="fileLoading" @click="fileInputRef.click()">
              {{ form.excel_file_id ? "Faylni almashtirish" : "Fayl yuklash" }}
            </el-button>
            <span v-if="fileName" class="file-name">{{ fileName }}</span>
          </div>
        </el-form-item>

        <div class="form-actions">
          <router-link to="/app/financial-statistic-public-sector-balance-sheet" class="el-button el-button--danger">
            Bekor qilish
          </router-link>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">
            Saqlash
          </el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage, ElNotification } from "element-plus";
import http from "@/http";
import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";

const route = useRoute();
const { id } = route.params;

const formRef = ref();
const fileInputRef = ref();
const loading = ref(false);
const fileLoading = ref(false);
const submitLoading = ref(false);
const fileName = ref(null);

const form = reactive({
  year: new Date().getFullYear(),
  excel_file_id: "",
});

const EXCEL_EXTS = [".xls", ".xlsx"];

const uploadFile = (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const ext = "." + file.name.split(".").pop().toLowerCase();
  if (!EXCEL_EXTS.includes(ext)) {
    ElMessage.error("Faqat Excel fayl (.xls, .xlsx) yuklash mumkin!");
    event.target.value = "";
    return;
  }
  if (file.size / 1024 / 1024 > 20) {
    ElMessage.error("Fayl xajmi max. 20MB bo'lishi kerak!");
    event.target.value = "";
    return;
  }
  const formData = new FormData();
  formData.append("file", file);
  fileLoading.value = true;
  http
    .post(`${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`, formData, {
      headers: {
        Authorization: store.state.accessToken,
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      form.excel_file_id = data.hashId;
      fileName.value = file.name;
      formRef.value?.clearValidate(["excel_file_id"]);
    })
    .catch(() => {
      ElMessage.error("Fayl yuklashda xatolik. Qayta urinib ko'ring!");
    })
    .finally(() => {
      fileLoading.value = false;
      event.target.value = "";
    });
};

const submitForm = () => {
  if (!formRef.value) return;
  formRef.value.validate((valid, fields) => {
    if (!valid) {
      Object.values(fields)
        .flat()
        .forEach((e) => ElMessage.error(e.message));
      return;
    }
    submitLoading.value = true;
    const url = id
      ? `api/v1/public-sector-balance-sheet/${id}`
      : "api/v1/public-sector-balance-sheet";
    const method = id ? "put" : "post";
    http({ url, data: { year: form.year, excel_file_id: form.excel_file_id }, method })
      .then(() => {
        ElMessage({ type: "success", message: "Muvaffaqqiyatli saqlandi" });
        router.push("/app/financial-statistic-public-sector-balance-sheet");
      })
      .catch(({ response }) => {
        ElNotification.error({
          message: response?.data?.message || "Xatolik, qayta urinib ko'ring",
        });
      })
      .finally(() => {
        submitLoading.value = false;
      });
  });
};

onMounted(() => {
  if (!id) return;
  loading.value = true;
  http
    .get(`api/v1/public-sector-balance-sheet/${id}`)
    .then(({ data }) => {
      form.year = data.year;
      form.excel_file_id = data.excel_file_id || "";
      fileName.value = data.file_name || null;
    })
    .catch(() => {
      ElMessage.error("Ma'lumot yuklashda xatolik!");
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>

<style scoped lang="scss">
.form-title {
  margin-bottom: 20px;
  font-weight: 600;
}
.psbs-form {
  max-width: 600px;
}
.file-upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.file-name {
  color: #606266;
  font-size: 14px;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  a {
    text-decoration: none;
  }
}
</style>
